/* eslint-disable no-unused-vars */
import Register from "./components/Register";
import ipConfig from "./ipConfig.json";
import Login from './components/Login';
import Products from "./components/Products";
import Checkout from "./components/Checkout";
import Thanks from "./components/Thanks";
import { Route, Switch } from "react-router-dom";
import theme from './theme';
import React from 'react';
export const config = {
  endpoint: `https://ultimatekart.herokuapp.com/api/v1`,
};

function App() {
  return (
     <React.StrictMode>
    <div className="App">
             <Switch>
                <Route exact path="/" component={Products}></Route>
                <Route path="/login" component={Login}></Route>
                <Route path="/register" component={Register}></Route>
                <Route path="/checkout" component={Checkout}></Route>
                <Route path="/thanks" component={Thanks}></Route>
             </Switch>
        
          {/* <Login/>
          <Register/> */}
          {/* <Products/> */}
    </div>
    </React.StrictMode>
  );
}

export default App;
